<template>
  <div>
    <!-- Filter CB Modal Start -->
    <b-button
      style="font-size: 0.675rem ;margin-left:5px ;margin-bottom:4px;"
      @click="FilterCB()"
      size="sm"
      variant="warning"
      >Booking No Search</b-button
    >
    <b-modal
      id="FilterCB-modal"
      ref="FilterCB-modal"
      title="Filter CB"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-8">
          <b-form-input
            class="mb-2 w-100"
            :formatter="capitalizeAll"
            v-model="filterCBNO"
            v-on:keyup="CBFilterFunct(true)"
            placeholder="Type to Search"
          />

        </div>
        <div class="col-md-4">
          <b-button @click="CBFilterFunct(false)">Clear</b-button>
          <small>{{ CBList.length }} Entries</small>
        </div>
        <div class="col-md-12">
          <h1>{{ DataSearch }}</h1>
          <CustomLoader v-if="ismodalLoding" :width="70"></CustomLoader>
          <b-table
            show-empty
            stacked="md"
            :items="CBList"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="booking_no" slot-scope="row1">
              <span v-if="row1.item.bookingType">
                Booking Type. :{{ row1.item.bookingType }}
                <br />
              </span>
              <span v-if="row1.item.contract_no">
                Contract No. :{{ row1.item.contract_no }}
                <br />
              </span>
              <b>{{ row1.item.booking_no }}</b>
              <br />
              <span>
                Created Dt. :{{ row1.item.created_at | moment }}
                <br />
              </span>
              <span>Release Dt. :{{ row1.item.release_date | moment }}</span>
              <br />
              <span>
                Raised From : {{ row1.item.raisedFrom }}
                <br />
              </span>
              <span>By : {{ row1.item.raisedBy }}</span>
              <br />

              <span class="error" v-if="row1.item.UpdatedBy">
                Update Dt : {{ row1.item.UpdatedDate }}
                <br />
              </span>
              <span class="error" v-if="row1.item.UpdatedBy"
                >Update By : {{ row1.item.UpdatedBy }}</span
              >
              <br />
            </template>
            <template slot="ClientName" slot-scope="row2">
              <b v-if="row2.item.fk_client_id == '0'">{{ "NOT AVAILABLE" }}</b>
              <b v-else-if="row2.item.ClientName != ''">{{ row2.item.ClientName }}</b>
            </template>
            <template slot="shippingLine" slot-scope="row3">
              <b v-if="row3.item.shippingLine != ''">{{ row3.item.shippingLine }}</b>
            </template>
            <template slot="POD" slot-scope="row3">
              Branch :
              <b v-if="row3.item.Branch_Name != ''">
                {{ row3.item.Branch_Name }}
              </b>
              <br />POR :
              <b v-if="row3.item.POR != ''">{{ row3.item.POR }}</b>
              <br />POD :
              <b v-if="row3.item.POD != ''">{{ row3.item.POD }}</b>
              <br />POL :
              <b v-if="row3.item.POL != ''">{{ row3.item.POL }}</b>
              <br />
            </template>
            <template slot="vessel_sale_start_date" slot-scope="row10">
              <b v-if="row10.item.validity_start != ''"
                >Validity Date : {{ row10.item.validity_start }}</b
              >
              <br />
              <b v-if="row10.item.validity_end != ''">/{{ row10.item.validity_end }}</b>
              <br />
              <b v-if="row10.item.vessel_sale_start_date != ''"
                >Vessel Sail Date : {{ row10.item.vessel_sale_start_date }}</b
              >
              <br />
              <b v-if="row10.item.vessel_sale_end_date != ''"
                >/{{ row10.item.vessel_sale_end_date }}</b
              >
              <br />
            </template>
            <template slot="mainSeries" slot-scope="row6">{{
              row6.item.mainSeries
            }}</template>
            <template slot="BookingStatus" slot-scope="row7">
               <BRFCard v-if="row7.item.prbr_id" :BRFDetails="null" :prbr_id="Number(row7.item.prbr_id)" />
              <b-badge>{{
                row7.item.isbookingactive == 1 ? "Active" : "In-Active"
              }}</b-badge
              ><br />
              <b-badge>{{
                row7.item.BookingStatus == 1
                  ? "RELEASED"
                  : row7.item.BookingStatus == 2
                  ? "UNRELEASED"
                  : row7.item.BookingStatus == 3
                  ? "CANCELLED"
                  : "All"
              }}</b-badge></template
            >
          </b-table>
        </div>
      </div>
      <b-button @click="hideFilterCB" variant="danger" class="pull-right mt-2">
        Close</b-button
      >
    </b-modal>
    <!-- Filter CB Modal End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import AccountService from "../../services/AccountService.js";
import BRFCard from "../common/brfCard.vue";

export default {
  props: ["allModuleIdProp", "JOBSERIES"],
  beforeMount() {},

  data() {
    return {
      ismodalLoding:false,
      CBList: [],
      filterCBNO: "",
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "booking_no",
          mainkey: "booking_no",
          label: "Booking No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shippingLine",
          mainkey: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "POD",
          mainkey: "POD",
          label: "Other Details",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "vessel_sale_start_date",
          mainkey: "vessel_sale_start_date",
          label: "DATE",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "mainSeries",
          mainkey: "mainSeries",
          label: "Sales Execution Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "BookingStatus",
          mainkey: "BookingStatus",
          label: "Booking Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
      ],
      DataSearch: "",
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    BRFCard,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    FilterCB() {
      this.$refs["FilterCB-modal"].show();
    },
    hideFilterCB() {
      this.$refs["FilterCB-modal"].hide();
    },
    CBFilterFunct(status) {
      this.CBList = [];
      if (status == true) {
        this.getCBFilterData(status);
        this.ismodalLoding = true; //to start the loader
        if (this.filterCBNO.length === 0) {
          this.ismodalLoding = false; //to stop the loader is there is no input
        }
      } else {
        this.filterCBNO = "";
        this.CBList = [];
        this.ismodalLoding = false; //to stop the loader is there is no input
      }
    },
    getCBFilterData(status) {
      this.DataSearch = "";
      if (
        this.filterCBNO != "" &&
        this.filterCBNO != undefined &&
        this.filterCBNO != null
      ) {
        let payload = {
          categoryType: "categoryType",
          searchVal: this.filterCBNO,
          searchFlag: status,
          dataType: "CBFilter",
          CBooking: "CBooking",
        };
        this.DataSearch = "Please Wait Searching in Process......";
        // this.ismodalLoding = true;
        AccountService.getAllCBList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.ismodalLoding = false;
              if (data.consoleBookingData.length > 0) {
                this.CBList = data.consoleBookingData;
                this.DataSearch = "";
                this.ismodalLoding = false;
              } else {
                this.ismodalLoding = false;
                this.DataSearch = "Sorry Data Not Found!!";
              }
            }
          })
          .catch((error) => {
            console.log("Catch on Console Booking List Error: ", error);
          });
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// filterCBModal.vue?0fb94592